import { useLocationContext } from 'contexts/LocationContext';
import { useSnowplow } from 'contexts/SnowplowContext';
import { useEffect } from 'react';
import {
  yleContextGenerator,
  activeEntityContextGenerator,
} from 'services/snowplowAnalytics/contextGenerators';
import { trackPageView } from 'services/snowplowAnalytics/snowplowAnalytics';
import { useUILanguage } from './useUILanguage';
import { Analytics } from '@yleisradio/areena-types';
import { useRouter } from 'next/router';

export function useTrackSnowplowPageView(
  analytics: Analytics | undefined
): void {
  const { isSnowplowReady } = useSnowplow();
  const { country_code: countryCode } = useLocationContext() || {};
  const language = useUILanguage();
  const ylePageloadAnalytics = analytics?.pageload?.yle;
  const { asPath: path } = useRouter();

  useEffect(() => {
    if (isSnowplowReady && ylePageloadAnalytics) {
      const section = ylePageloadAnalytics['areena_view_type'] || 'page';
      const yleContext = yleContextGenerator({
        countryCode,
        language,
        section,
      });
      const activeEntity = activeEntityContextGenerator(
        ylePageloadAnalytics.entity_type,
        ylePageloadAnalytics.id,
        ylePageloadAnalytics.version
      );

      trackPageView(yleContext, activeEntity);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isSnowplowReady, path]);
}
